<template>
    <form
        class="form"
        @submit.prevent="handleSubmit">
        <div class="greeting">
            Hi, How may i address you?
        </div>
        <input
            class="input input--name"
            type="text"
            v-model="name">
    </form>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "WelcomeForm",
    data() {
        return { name: "" };
    },
    computed: mapState(["userName"]),
    methods: {
        handleSubmit() {
            this.$store.commit("setUserName", this.name);
            // cache the user name in localStorage
            localStorage.setItem("userName", this.name);
            // go to the main view
            this.$router.push("/");
        }
    },
    created() {
        // when the welcome form is created, if the name cache 
        // (retrieved from localStorage before the store is created) exsists, make it a local copy for the form
        this.name = this.userName;
    }
};
</script>
  
<style scoped>
.greeting {
    margin-bottom: 4rem;
    font-size: 4rem;
    font-weight: 500;
}

.input--name {
    margin: 0 auto;
    font-size: 2.5rem;
    font-weight: 400;
}
</style>